const hostname = window.location.hostname;
export const isFrance = hostname === 'lepickleballshop.com';
export const isPortugal = hostname === 'eupickleballshop.com';
